<template>
    <div class="container">
        <knowledgeMenu @knowledgeSelect="knowledgeSelect"/>
        <div>
            <div class="introduction">
                <div class="introductionTitle">
                    <h1 data-aos="fade-up">BioTank专病精准医学知识图谱系统</h1>
                    <div data-aos="fade-up"></div>
                    <div data-aos="fade-up" style="word-break:break-all;word-wrap:break-word;">
                      BioTank专病精准医学知识图谱系统，是面向专病领域知识收集、管理与挖掘的人工智能科研信息系统。系统针对专病相关文献、临床数据、组学数据及公共数据库信息开展深度挖掘与知识提取，构建涵盖基因、蛋白、代谢产物、治疗策略等各类实体及其关联关系的知识网络，实现对疾病领域知识的系统性梳理与重构。
                    </div>
                    <div data-aos="fade-up" style="word-break:break-all;word-wrap:break-word;">
                      依托知识网络及自研推理模型与算法，系统可对录入的临床表型与生物标记开展科研层面的分析解析，挖掘其与已知生物网络的对应关联，输出疾病风险分析提示、治疗靶点挖掘线索、药物候选筛选线索等科研参考信息，可为专病科研、靶点研究、药物研发等研究场景提供技术支撑。
                    </div>
                </div>
                <div data-aos="zoom-in">
                    <img :src="require('@/assets/img/knowledge/special/introductionTitle.png')" alt="">
                </div>
            </div>
            <div class="plan">
              <div style="margin-left:300px" data-aos="fade-up">
                <img src="../../assets/img/about/academic/title.jpg">
              </div>
<!--                <div class="title" >系统功能</div>-->
                <div class="content">
                    <div class="left" data-aos="fade-right"><img :src="plan[0].img" alt=""></div>
                    <div class="right">
                        <div v-for="item in plan[0].content" :style="{background:'url('+item.img+') no-repeat','background-size':'100% 100%'}"  data-aos="fade-left">
                            <div class="contentTitle">
                                {{item.title}}
                            </div>
                            <div class="contentList">
                                <div v-for="list in item.list">{{list}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content content1">
                    <div class="right">
                        <div v-for="item in plan[1].content" :style="{background:'url('+item.img+') no-repeat','background-size':'100% 100%'}"  data-aos="fade-right">
                            <div class="contentTitle">
                                {{item.title}}
                            </div>
                            <div class="contentList">
                                <div v-for="list in item.list">{{list}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="left" data-aos="fade-left"><img :src="plan[1].img" alt=""></div>
                </div>
                <div class="content content2">
                    <div class="left" data-aos="fade-right"><img :src="plan[2].img" alt=""></div>
                    <div class="right">
                        <div v-for="item in plan[2].content" :style="{background:'url('+item.img+') no-repeat','background-size':'100% 100%'}"  data-aos="fade-left">
                            <div class="contentTitle">
                                {{item.title}}
                            </div>
                            <div class="contentList">
                                <div v-for="list in item.list">{{list}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import knowledgeMenu from "../../components/knowledgeMenu";
export default {
    name:'Special',
    components: {
	    knowledgeMenu
    },
    data(){
      return {
            plan:[
                {
                    img:require('@/assets/img/knowledge/special/planLeft1.png'),
                    content:[
                        {
                            img:require('@/assets/img/knowledge/special/planRight1.png'),
                            title:'平台检索和查询功能',
                            list:[
                                '1.支持9大类实体的检索，基因、蛋白、疾病、药物、RNA等，和这9大类的实体的标准名、编码; ',
                                '2.支持同名以及模糊查询，可以检索到具体基因;',
                                '3.可以用GeneBrowser的形式展示与具体基因相关的RNA、IncRNA、miRNA和突变的展示，为科研工作者更直观的展示相关内容;',
                                '4.可以检索到与具体基因相关的其他实体比如通路和蛋白，对于每个实体都会展示实体的基本，本体的相关位置以及与其他实体的关联;',
                                '5.可以在药物的检索页面看到药物相关的基本信息以及与其相关联的实体内容。'
                            ]
                        },
                        {
                            img:require('@/assets/img/knowledge/special/planRight2.png'),
                            title:'通路展示功能',
                            list:[
                                '1.对于通路展示不仅有文字形式展示通路的介绍和作用，还有通路的展示图;',
                                '2.对标IPA平台的功能，以精准医学知识库数据为基础的疾病、蛋白互作和药物等网络的基础上，实现了以基因/蛋白质为核心，基于精准医学知识库的通路网络分析展示系统；',
                                '3.系统支持疾病、蛋白质和药物等相关的通路的检索、可视化与分析等功能。'
                            ]
                        },
                        {
                            img:require('@/assets/img/knowledge/special/planRight3.png'),
                            title:'基因列表数据上传及注释分析选择',
                            list:[
                                '1.支持基因列表的定性数据注释分析;',
                                '2.支持对于定量时序表达基因进行数据注释分析，用户可以上传基因数据文件或者直接粘贴，提供基因样例数据，实现了以基因为中心的精准医学知识库注释分析功能模块的重新分类，提升了用户的使用友好性。',
                            ]
                        }
                    ]
                },
                {
                    img:require('@/assets/img/knowledge/special/planLeft2.png'),
                    content:[
                        {
                            img:require('@/assets/img/knowledge/special/planRight4.png'),
                            title:'基于PMO中以基因功能为代表的本体注释分析',
                            list:[
                                '基于项目自产的精准医学知识库本体系统PMO，对用户提交的基因列表，进行注释分析，结果以表格视图(Table View)或树形视图 (Tree View) 展示富集或缺失的类别，其中深红和深绿分别表示显著富集或缺失的条目。同时为用户提供PMO条目节点溯源功能，用户勾选类别进行节点溯源展示，结果以层次网络(DAGView)的方式展示了选中条目以及溯源的父节点的关系。'
                            ]
                        },
                        {
                            img:require('@/assets/img/knowledge/special/planRight5.png'),
                            title:'基于PMO中通路Pathway注释分析',
                            list:[
                                '1.可以提供通路的富集分析的表格式的结果',
                                '2.可以为用户提供通路图展示功能;',
                                '3.分析结果展示体系优化，以不同颜色来标注P-Value值等富集分析结果'
                            ]
                        },
                        {
                            img:require('@/assets/img/knowledge/special/planRight6.png'),
                            title:'基于多种分子网络的注释分析模块',
                            list:[
                                '1.整合蛋白相互作用数据(STRING/HPRD)、转录调控关系数据(TF-TG)、磷酸化激酶和作用底物关系数据 (Kinase-substrate) 、泛素连接酶和底物作用关系数据 (Ubiquitin liganse-substrate) 等多个生物学网络数据;',
                                '2.构建在生物学网络层次上注释基因的工作流',
                            ]
                        },
                        {
                            img:require('@/assets/img/knowledge/special/planRight7.png'),
                            title:'组学数据与知识库相结合的数据分析模块',
                            list:[
                                '1.基于项目收集的TCGA泛癌的数据，包括基因组、转录组、蛋白质组等多组学数据，通过构建共识聚类模型算法，建立了癌症分子分型的分析模块，并抽提到用于特征分类的关键基因，进一步对于关键基因可以结合临床数据，实现生存分析等;',
                                '2.对于每个关键基因，都有着丰富的多维度的知识库注释信息，可以点击基因进行跳转查看等.',
                            ]
                        }
                    ]
                },
                {
                    img:require('@/assets/img/knowledge/special/planLeft3.png'),
                    content:[
                        {
                            img:require('@/assets/img/knowledge/special/planRight8.png'),
                            title:'查询功能',
                            list:[
                                '1.主要包含三种查询功能: Entity查询，ShortestPath查询，Adjacent查询;',
                                '2.Entity查询是从任意一个基因型(GP、Variation)或药物关键字到意一类节点的查询: From【关键字填写框**】 to【目标类型选择菜单框**】(*限制为一种基因或基因产物、突变或药物) (**五种类型可选:“基因及其产物”“变异”“药物”“疾病”“通路”);',
                                '3.ShortestPath查询是任意两个关键字(如“KRAS”和“hypertension”)之间的最短路径查询: From【关键字填写框】to【关键字填写框】;',
                                '4.Adjacent查询需要输出一级连接(需配合节点上点击右键，选择输出全部某一类别下的一级连接节点)：Adjacent to【关键字填写框】任意关键字的一级连接节点的输出。'
                            ]
                        },
                        {
                            img:require('@/assets/img/knowledge/special/planRight9.png'),
                            title:'知识推送功能',
                            list:[
                                '1.系统搭建了基于OpenInfoButton 的知识库订阅管理器；',
                                '2.知识库订阅管理器提供了一个平台，在这个平台上可以维护知识库的说明文件 (profile)，这个说明文2件用来管理哪些客户端可以通过哪种方式访问知识库的哪些内容，并提供知识查询的集成浏览视图;',
                                '3.知识库中除了兼容HL7Openlnfobutton协议的知识源外，针对其他知识源也提供了基于URL规则的知识3编辑，可以适用大多数基于Web的知识平台；',
                                '4.提供基于Openlnfobutton的知识查询服务接口，通过查询各个配置的知识源的信息，针对查询所涉及的4知识需求，提供统一的知识查询入口，同时根据配置的知识源能够集成精准显示各类知识源中特定的知识；',
                                '5.具备精准医学生物信息资源的收集、汇总、审核与分类展示功能。'
                            ]
                        },
                    ]
                },
            ]
      }
    },
    methods:{
        knowledgeSelect(src){
	        this.$emit('knowledgeSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1071px;
        margin: 178px auto 0;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            width: 500px;
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 1px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 3px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3),&>div:nth-child(4){
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 25px;
                letter-spacing: 1px;
                color: #333333;
                text-indent: 2em;
            }
        }
    }
    .plan{
        width: 100%;
        margin-top: 138px;
        .title{
            width: 391px;
            height: 60px;
            background: url("../../assets/img/about/academic/planTitle.png") no-repeat;
            margin: 0 auto;
            font-size: 27px;
            line-height: 27px;
            color: #ed1c24;
            letter-spacing: 6px;
            text-align: center;
        }
        .content{
            width: 1092px;
            margin: 70px auto 0px;
            display: flex;
            justify-content: space-between;
            .right{
                width: 834px;
                &>div{
                    width: 100%;
                    padding: 20px 38px 20px 56px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 17px;
                    box-sizing: border-box;
                    .contentTitle{
                        width: 168px;
                        height: 130px;
                        border-right: 2px solid #006efd;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        font-size: 22px;
                        font-weight: normal;
                        font-stretch: normal;
                        line-height: 40px;
                        letter-spacing: 2px;
                        color: #333333;
                    }
                    .contentList{
                        width: 576px;
                        padding-left: 28px;
                        box-sizing: border-box;
                        font-size: 15px;
                        font-weight: normal;
                        font-stretch: normal;
                        line-height: 25px;
                        letter-spacing: 1px;
                    }
                }
            }
        }
        .content1{
            .right{
                &>div{
                    margin-bottom: 44px;
                    .contentTitle{
                        line-height: 30px;
                    }
                }
            }
        }
        .content2{
            .right{
                &>div{
                    margin-bottom: 40px;
                    .contentTitle{
                        height: 240px;
                    }
                }
            }
        }
    }
</style>
